<template>
    <b-container fluid class="px-4">
        <hr />
        <b-row class="align-items-center justify-content-lg-between">
            <b-col cols="col-lg-6">
                <div class="copyright text-center text-lg-left text-muted">
                    © {{ year }}
                    <a
                        href="https://www.innovate10x.com"
                        class="font-weight-bold ml-1"
                        target="_blank"
                        >Innovate 10x</a
                    >
                    "Powering What's Next"
                </div>
            </b-col>
            <b-col cols="6"
                ><span class="float-right"> Version 1.5</span></b-col
            >
        </b-row>
    </b-container>
</template>
<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(),
        }
    },
}
</script>
<style></style>
